import React from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";

// Restrained world-map (dotted continents) with a few gold connection nodes.
const NODES = [
  { x: 47, y: 38, label: "UK" },
  { x: 52, y: 62, label: "Ghana" },
  { x: 60, y: 45, label: "Gulf" },
  { x: 25, y: 55, label: "Caribbean" },
  { x: 22, y: 40, label: "US" },
];

export default function GlobalReach({ content }) {
  const eyebrow = content?.eyebrow || "Global Reach";
  const line1 = content?.heading_line1 || "Selected Markets.";
  const line2 = content?.heading_line2 || "Strategic Connections.";
  const body = content?.body || "Our sourcing model enables Goldstone Sourcing to identify opportunities across selected international markets through direct relationships, developers, suppliers, partners and specialist networks.";
  return (
    <section data-testid="global-reach" className="relative overflow-hidden border-y border-gold/10 bg-seablue/25 px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <Eyebrow>{eyebrow}</Eyebrow>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">
              {line1}<br /><span className="text-gradient-gold italic">{line2}</span>
            </h2>
            <p className="mt-6 max-w-lg font-sans text-sm leading-relaxed text-softgrey">{body}</p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative aspect-[16/9] w-full border border-gold/15 bg-obsidian/60">
              <svg viewBox="0 0 100 56" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
                <defs>
                  <pattern id="dots" width="1.6" height="1.6" patternUnits="userSpaceOnUse">
                    <circle cx="0.5" cy="0.5" r="0.28" fill="#A7ADB2" opacity="0.18" />
                  </pattern>
                </defs>
                {/* stylised landmasses as dotted blobs */}
                <g fill="url(#dots)">
                  <ellipse cx="22" cy="26" rx="12" ry="8" />
                  <ellipse cx="27" cy="42" rx="7" ry="9" />
                  <ellipse cx="49" cy="24" rx="9" ry="6" />
                  <ellipse cx="52" cy="40" rx="8" ry="11" />
                  <ellipse cx="66" cy="30" rx="14" ry="9" />
                  <ellipse cx="80" cy="44" rx="6" ry="4" />
                </g>
                {/* connection lines */}
                {NODES.map((n, i) =>
                  NODES.slice(i + 1).map((m, j) => (
                    <line key={`${i}-${j}`} x1={n.x} y1={n.y} x2={m.x} y2={m.y}
                          stroke="#C9A227" strokeWidth="0.12" opacity="0.28" />
                  ))
                )}
                {NODES.map((n, i) => (
                  <g key={i}>
                    <circle cx={n.x} cy={n.y} r="1.4" fill="#C9A227" opacity="0.25">
                      <animate attributeName="r" values="1.4;3;1.4" dur="3s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
                    </circle>
                    <circle cx={n.x} cy={n.y} r="0.9" fill="#E5C76B" />
                  </g>
                ))}
              </svg>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
